<template>
  <div class="exam-calc">
    <md-layout
      :md-gutter="24"
      md-flex="100"
    >
      <md-layout
        md-flex="100"
        class="inputs-calc"
      >
        <md-input-container>
          <label>IgG líquor (mg/dl)</label>
          <md-input
            id="igGLiquor"
            v-model="exam.fields.igGLiquor"
            v-validate="'required'"
            v-mask="igGLiquor"
            data-vv-validate-on="none"
            name="igGLiquor"
            title="IgG Líquor (mg/dl)"
            placeholder="IgG Líquor (mg/dl)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.igGLiquor"
            v-mask="igGLiquor"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>IgG soro (mg/dl)</label>
          <md-input
            id="igGSerum"
            v-model="exam.fields.igGSerum"
            v-validate="'required'"
            v-mask="igGSerum"
            data-vv-validate-on="none"
            name="igGSoro"
            title="IgG soro (mg/dl)"
            placeholder="IgG soro (mg/dl)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.igGSerum"
            v-mask="igGSerum"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>Albumina líquor (mg/dl)</label>
          <md-input
            id="albuminLiquor"
            v-model="exam.fields.albuminLiquor"
            v-validate="'required'"
            v-mask="albuminLiquor"
            data-vv-validate-on="none"
            name="albuminLiquor"
            title="Albumina líquor (mg/dl)"
            placeholder="Albumina líquor (mg/dl)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.albuminLiquor"
            v-mask="albuminLiquor"
            type="hidden"
          >
        </md-input-container>

        <md-input-container>
          <label>Albumina soro (g/dL)</label>
          <md-input
            id="serumAlbumin"
            v-model="exam.fields.serumAlbumin"
            v-validate="'required'"
            v-mask="serumAlbumin"
            data-vv-validate-on="none"
            name="serumAlbumin"
            title="Albumina soro (g/dL)"
            placeholder="Albumina soro (g/dL)"
            @keyup.enter.native="calculate()"
          />
          <input
            v-model="exam.fields.serumAlbumin"
            v-mask="serumAlbumin"
            type="hidden"
          >
        </md-input-container>

        <button
          class="btn btn-primary btn-calc"
          @click="calculate()"
        >
          Calcular
        </button>
      </md-layout>
    </md-layout>
    <div class="calc-card__result">
      <template>
        <p>
          Resultado: <span>{{ exam.result }}mg/dL</span>
        </p>
      </template>
    </div>
  </div>
</template>
<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'CalcIndiceIggLiquor',
  data: () => {
    return {
      exam: {
        fields: {
          igGLiquor: null,
          igGSerum: null,
          albuminLiquor: null,
          serumAlbumin: null
        },
        result: 0
      },
      igGLiquor: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 4
      }),
      igGSerum: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 4
      }),
      albuminLiquor: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 4
      }),
      serumAlbumin: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2,
        requireDecimal: false,
        allowLeadingZeroes: true,
        integerLimit: 4
      })
    }
  },
  methods: {
    calculate() {
      if (
        this.exam.fields.igGLiquor &&
        this.exam.fields.igGSerum &&
        this.exam.fields.albuminLiquor &&
        this.exam.fields.serumAlbumin
      ) {
        const igGLiquor = +this.exam.fields.igGLiquor
        const igGSerum = +this.exam.fields.igGSerum
        const albuminLiquor = +this.exam.fields.albuminLiquor
        const serumAlbumin = +this.exam.fields.serumAlbumin

        this.exam.result = (igGLiquor / albuminLiquor / (igGSerum / (serumAlbumin * 1000))).toFixed(2)
      }
    }
  }
}
</script>
